import { useState } from "react"
import { Button, Col, Container, Row, Stack } from "react-bootstrap"
import { useParams } from "react-router"
import { navigateTo } from "../../../redux/router/routerActions"
import { useAppDispatch } from "../../../redux/store"
import { useDeleteTurnoverMutation, useGetTurnoverByIdQuery } from "../../../services/bClientApi"
import TurnoverEntry from "../../../Components/Turnover/TurnoverEntry/TurnoverEntry"

export default function DeleteTurnoverPage() {

    const [
        deleteTurnover,
        {
            isLoading: deleteLoading,
            error: deleteError
        }
    ] = useDeleteTurnoverMutation()

    const { turnoverId = '' } = useParams()
    const dispatch = useAppDispatch()

    const [deleteClicked, setDeleteClicked] = useState(false)

    const {
        data,
        error,
        isLoading
    } = useGetTurnoverByIdQuery(turnoverId, { skip: !turnoverId || deleteClicked })
    const turnoverData = data || {}

    const turnoverDeleteFn = async () => {
        if (turnoverId) {
            const deleteValue = await deleteTurnover(turnoverId).unwrap()
            if (deleteValue) {
                dispatch(navigateTo('/turnovers/'))
            }
        }
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Delete Turnover</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}
                    {deleteError && (<>{JSON.stringify(deleteError)}<br /></>)}

                    {turnoverId && turnoverData && !isLoading && (
                        <div className="turnover-info">
                            <div className="mb-4">
                                <h4>Turnover to Delete</h4>
                                <TurnoverEntry
                                    turnoverData={turnoverData}
                                    fullView={true}
                                    showActions={false}
                                />
                            </div>

                            <Stack gap={3}>
                                <div className="alert alert-warning">
                                    <strong>Warning!</strong> Are you sure you want to delete this turnover? This action cannot be undone.
                                </div>
                                <div>
                                    <Button
                                        variant="secondary"
                                        className="me-2"
                                        onClick={() => dispatch(navigateTo(`/turnovers/${turnoverId}`))}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="warning"
                                        onClick={() => setDeleteClicked(true)}
                                        disabled={deleteClicked}
                                    >
                                        Delete Turnover
                                    </Button>
                                </div>
                                {deleteClicked && (
                                    <div className="alert alert-danger">
                                        <strong>Final Confirmation:</strong> This turnover will be permanently deleted. This action cannot be undone.
                                        <br /><br />
                                        <Button
                                            variant="danger"
                                            disabled={deleteLoading}
                                            onClick={() => {
                                                turnoverDeleteFn()
                                            }}
                                        >
                                            {deleteLoading ? 'Deleting...' : 'Confirm Delete Turnover'}
                                        </Button>
                                    </div>
                                )}
                            </Stack>

                        </div>
                    )}
                </Col>
            </Row>
        </Container>
    )
}
